import MatchesHeader from "./matchesheader";
import MatchesContent from "./matchesContent";
import "./matchesPanel.sass";

export default function MatchesPanel({ TABS, groupId, group, standings, onChangeScore, onSelectGroup, onSimulateGroup, groupsState = {} }) {
  return (
    <div className="MatchesPanel">
      <MatchesHeader 
        TABS={TABS}
        groupId={groupId}
        standings={standings}
        group={group}
        onSelectGroup={onSelectGroup}
        onSimulateGroup={onSimulateGroup}
        groupsState={groupsState}
      />

      <MatchesContent 
        groupId={groupId}
        days={group?.days ?? []}
        onChangeScore={onChangeScore}
      />
    </div>
  );
}